// extracted by mini-css-extract-plugin
export default {"card":"CustomerReferenceGuideCard_card__oP10j","buttons":"CustomerReferenceGuideCard_buttons__DxJrB"};